import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem } from 'primeng/primeng';
import { BaseStepComponent } from "app/base";

@Component({
    selector: 'trilha-auditoria-etapa2',
    templateUrl: './trilha-auditoria-etapa2.component.html',
})
export class CrudTrilhaAuditoriaEtapa2Component extends BaseStepComponent {
    @Input() SistemaOptions: SelectItem[];
    @Input() PerfilOptions: SelectItem[];
    @Input() FuncionalidadeOptions: SelectItem[];
    @Input() listaSistema: any[];
    @Input() listaStatus: any[];
}


// WEBPACK FOOTER //
// ./src/app/trilha-auditoria/crud/etapas/trilha-auditoria-etapa2.component.ts